export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40e0021704a38364d535d94a899ff209f7aef24c5a&name=revalidateCommunity!'